import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import {getClassName} from '../../../../helpers/dom-helpers';
/* styles */
import './textarea.scss';

class Textarea extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      isFocused: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.autoFocusTimeout = setTimeout(() => {
        this.textarea.focus();
      }, this.props.autoFocusDelay);
    }
  }

  componentWillUnmount() {
    if (this.autoFocusTimeout) {
      clearTimeout(this.autoFocusTimeout);
    }
    if (this.changeDebounce) {
      clearTimeout(this.changeDebounce);
    }
  }

  onOuterDivBlur = () => {
    this.setState({isFocused: false});
  };

  onChange = (event, value) => {
    if (this.textareaTimeout) {
      clearTimeout(this.textareaTimeout);
    }
    this.setState(
      {
        value: value !== undefined ? value : event.target.value,
      },
      () => {
        if (this.changeDebounce) {
          clearTimeout(this.changeDebounce);
        }
        this.changeDebounce = setTimeout(() => {
          this.props.onChange(this.state.value);
        }, this.props.changeDebounce);
      }
    );
  };

  onFocusChange = (isFocused) => {
    if (this.props.onFocusChange) {
      this.props.onFocusChange(isFocused);
    }
    if (isFocused !== this.state.isFocused) {
      this.setState({isFocused});
    }
  };

  render() {
    const className = getClassName('glu-textarea', this.props.className, {
      'glu-textarea--disabled': this.props.disabled,
      'glu-textarea--focused': !this.props.disabled && this.state.isFocused,
      'glu-textarea--warning': this.props.invalid && this.props.warning,
      'glu-textarea--invalid': this.props.invalid && !this.props.warning,
    });
    return (
      <div
        className={className}
        title={this.props.title}
        onClick={!this.props.disabled ? this.props.onClick : undefined}
        onBlur={this.onOuterDivBlur}
      >
        <textarea
          key="textarea"
          autoComplete={this.props.autoComplete}
          readOnly={this.props.readOnly}
          ref={(textarea) => {
            this.textarea = textarea;
          }}
          className="glu-textarea__textarea"
          name={this.props.name || this.props.id}
          id={this.props.id}
          value={this.state.value}
          placeholder={this.props.placeholder}
          onChange={this.onChange}
          onFocus={this.onFocusChange.bind(this, true)}
          onBlur={this.onFocusChange.bind(this, false)}
          disabled={this.props.disabled}
        />
        {this.props.maxChar ? (
          <p className="glu-textarea__counter text-right">
            {this.state.value.length}/{this.props.maxChar}
          </p>
        ) : null}
      </div>
    );
  }
}

Textarea.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  autoFocusDelay: PropTypes.number,
  changeDebounce: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  name: PropTypes.string,
  maxChar: PropTypes.number,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocusChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  warning: PropTypes.bool,
  title: PropTypes.string,
};

Textarea.defaultProps = {
  autoComplete: undefined,
  autoFocus: false,
  autoFocusDelay: 500,
  changeDebounce: 50,
  className: '',
  disabled: false,
  id: undefined,
  invalid: false,
  name: '',
  maxChar: 0,
  onChange: undefined,
  onClick: undefined,
  onFocusChange: undefined,
  placeholder: '',
  readOnly: false,
  value: '',
  warning: false,
  title: '',
};

export default Textarea;
